import { useEffect, useState } from 'react';
import { getBorrowerReferralLink } from '../../api/agent';

export default function useBorrowerReferralLink(): [
  string,
  () => Promise<string | false>
] {
  const [response, setResponse] = useState<string>('');

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const r = await getBorrowerReferralLink();
      setResponse(r);
      return r;
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    return false;
  }

  return [response, getData];
}
